<input type="text" [(ngModel)]="value" class="form-control light-blue-border" placeholder="HH:MM" aria-label="Time" (input)="onChange($any($event.target).value)" [ngClass]="{ 'ng-invalid': _control?.control?.invalid }" maxlength="6"
       (blur)="onTouched(); this.focusLost.emit()" (touchend)="onTouched(); this.focusLost.emit()"
       [disabled]="disabled">
